
import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { ConfigService } from '../../config/config.service';
import { SessionService } from './session.service';
import { CommonDataService } from './common-data.service';
import { httpExtensionService } from './httpextension.service';
@Injectable()
export class FundraisingService {

  constructor(private http: httpExtensionService, private config: ConfigService, private sessionService: SessionService, private commonDataService: CommonDataService) { }



  createAccount(userData) {
    let body = this.commonDataService.urlDataDecoded(userData);
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    return this.http.post(this.config.apiURI + this.config.createAccount, body, {
        headers: headers
    })
}

}



// WEBPACK FOOTER //
// ./src/app/shared/services/fundraising.service.ts